import React, { useEffect, useState } from 'react';
import { withTranslation } from '../../ChildrenContext';
import PropTypes from 'prop-types';
import UserStore from '../../../stores/UserStore';
import userApi from '../../../api';

const TimezonesPage = ({ t }) => {
    const staticNames = t?.TimezonesPage || {};
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timezones = Object.keys(UserStore.getTranslation().timezones || {});
        userApi.checkTimezones({ currentTimezones: timezones.join(',') })
            .then((data) => setResult(data))
            .catch((err) => setError(err?.message || String(err)))
            .finally(() => setLoading(false));
    }, []);

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title || 'Timezones check'}</h2>
                </div>
            </div>
            <section className="wrapper-content">
                {loading && <p>Loading…</p>}
                {error && <pre style={{ color: 'red' }}>{String(error)}</pre>}
                {!loading && !error && result && (
                    <pre>{JSON.stringify(result, null, 2)}</pre>
                )}
            </section>
        </React.Fragment>
    );
};

TimezonesPage.propTypes = { t: PropTypes.object };
TimezonesPage.defaultProps = { t: {} };
export default withTranslation(TimezonesPage);
